import memoizeOne from 'memoize-one';
import { connect } from 'react-redux';
import { State as AeMaxPriceState, Update } from '~/AeMaxPrice/reducer';
import { ReferenceBasketVersion } from '~/Api/PriceReferencing';
import { UserProductGroup } from '~/Api/User/ProductGroup';
import { Module, selectReferenceBasketVersions, State as PriceReferencingState } from '~/PriceReferencing';
import { Status, Statuses } from '~/UI/SaveActivityIndicator/SaveActivityIndicator';

import ParametersPanel from './ParametersPanel';

interface State {
	priceReferencing: PriceReferencingState;
	aeMaxPrice: AeMaxPriceState;
}

interface OwnProps {
	group: UserProductGroup;
}

const selectUpdateStatus = memoizeOne((groupId: string, update: Update | null) => {
	if (!update || update?.groupId !== groupId) {
		return null;
	}

	switch (update.state.name) {
		case 'scheduled':
		case 'fetching':
			return Statuses.saving;
		case 'updated':
			return Statuses.saved;
		case 'failed':
			return Statuses.failed;
		default:
			return null;
	}
});

function mapStateToProps(
	{ aeMaxPrice, priceReferencing }: State,
	{ group }: OwnProps
): { updateStatus: Status | null; versions: ReferenceBasketVersion[] | null } {
	return {
		updateStatus: selectUpdateStatus(group.id, aeMaxPrice.update),
		versions: selectReferenceBasketVersions(priceReferencing, Module.aeMaxPrice),
	};
}

export default connect(mapStateToProps)(ParametersPanel);
